import useDebounce from 'hooks/useDebounce';
import useProductList, {ProductTypeFilter} from 'hooks/useProductList';
import React, {useCallback, useEffect, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Products from './Products';
import useSort from 'hooks/useSort';

type Props = {};

const ProductsContainer: React.VFC<Props> = () => {
  const {params} = useRouteMatch<{page: string | undefined}>();
  const [currentPage, setCurrentPage] = useState(parseInt(params.page || '1'));
  const [productType, setProductType] = useState<ProductTypeFilter>('');
  const [search, setSearch] = useState('');
  const searchDebounced = useDebounce(search, 1000);
  const [pageSize, setPageSize] = useState(40);

  const {sortBy, sortOrder, order, onSort} = useSort('id', 'desc');

  const {products, totalPages, refetch, count, isLoading, total_prescriptions} =
    useProductList({
      page: currentPage - 1,
      search: searchDebounced,
      productType,
      ordering: order,
      pageSize,
    });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchDebounced]);

  useEffect(() => {
    if (params.page) {
      setCurrentPage(parseInt(params.page));
    }
  }, [params.page]);

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearch(e.target.value);
      setCurrentPage(1);
    },
    [setSearch, setCurrentPage]
  );

  return (
    <Products
      count={count}
      sortBy={sortBy}
      onSort={onSort}
      sortOrder={sortOrder}
      search={search}
      refetch={refetch}
      products={products}
      productType={productType}
      onProductTypeChange={setProductType}
      handleSearchChange={handleSearchChange}
      totalPages={totalPages}
      currentPage={currentPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      isLoading={isLoading}
      setCurrentPage={setCurrentPage}
      totalPrescriptions={total_prescriptions}
    />
  );
};

export default ProductsContainer;
